import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FILE_TYPE_PRESETS, presetState, toggleExtension, togglePreset } from './fileTypePresets';

const CHECK_ICON = { all: 'check_circle', partial: 'remove_circle', none: 'radio_button_unchecked' };

// „Synchronizovať typy súborov" — kategórie + rozbaľovacie „Upresniť prípony" nad jedným zoznamom vylúčených prípon.
// Rozbaľovačka je pri otvorení mapovania otvorená, ak má niektorá kategória vynechané len niektoré prípony
// (stránka dáva key podľa mapovania, aby sa to vyhodnotilo pre každé zvlášť).
const FileTypeFilter = ({ excluded, onChange }) => {
  const [t] = useTranslation('global');
  const [refineOpen] = useState(() => FILE_TYPE_PRESETS.some(preset => presetState(preset, excluded) === 'partial'));

  return (
    <div className="sp-file-type-settings">
      <label>{t('includedFileTypes') || 'Synchronizovať typy súborov'}</label>
      <span className="sp-hint">{t('includedFileTypesHint') || 'Synchronizujú sa len typy, ktoré Millada vie spracovať; ostatné súbory sa ignorujú. Odškrtnutím typ vynecháte.'}</span>
      <div className="sp-file-type-presets">
        {FILE_TYPE_PRESETS.map(preset => {
          const state = presetState(preset, excluded);
          return (
            <button
              key={preset.key}
              type="button"
              data-exts={preset.extensions.join(', ')}
              className={`sp-file-type-chip${state === 'none' ? '' : ' included'}${state === 'partial' ? ' partial' : ''}`}
              aria-pressed={state === 'partial' ? 'mixed' : state === 'all'}
              onClick={() => onChange(togglePreset(preset, excluded))}
            >
              <span className={`sp-ft-ico cat-${preset.key}`}>
                <span className="material-symbols-outlined">{preset.icon}</span>
              </span>
              <span className="sp-ft-name">{t(`fileType_${preset.key}`)}</span>
              <span className="sp-ft-check material-symbols-outlined">{CHECK_ICON[state]}</span>
            </button>
          );
        })}
      </div>

      <details className="sp-help-detail sp-ext-refine" open={refineOpen}>
        <summary>
          <span>{t('refineExtensions') || 'Upresniť prípony'}</span>
          <span className="sp-ext-summary">
            {excluded.length
              ? t('excludedExtensionsSummary', { list: excluded.join(', ') })
              : (t('noExtraExclusions') || 'Synchronizujú sa všetky prípony zaškrtnutých typov')}
          </span>
        </summary>
        <div className="sp-help-detail-body">
          <span className="sp-hint">{t('refineExtensionsHint') || 'Odškrtnutá prípona sa nesynchronizuje. Klik na typ hore zapne všetky jeho prípony.'}</span>
          {FILE_TYPE_PRESETS.map(preset => (
            <div key={preset.key} className="sp-ext-row">
              <span className="sp-ext-row-name">{t(`fileType_${preset.key}`)}</span>
              <div className="sp-ext-list">
                {preset.extensions.map(extension => (
                  <label key={extension} className="sp-ext-option">
                    <input
                      type="checkbox"
                      checked={!excluded.includes(extension)}
                      onChange={() => onChange(toggleExtension(extension, excluded))}
                    />
                    {extension}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      </details>
    </div>
  );
};

export default FileTypeFilter;
